import { render, staticRenderFns } from "./CategoryLayout.vue?vue&type=template&id=e9665cde&scoped=true"
import script from "./CategoryLayout.vue?vue&type=script&lang=js"
export * from "./CategoryLayout.vue?vue&type=script&lang=js"
import style0 from "./CategoryLayout.vue?vue&type=style&index=0&id=e9665cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9665cde",
  null
  
)

export default component.exports